import NewsGrid from '../components/NewsGrid'
import Video from '../components/Video'
import mobile from '../assets/videos/newsMob.mp4'
import desktop from '../assets/videos/newsDesktop.mp4'
import mobilePoster from '../assets/videos/newsMobPoster.avif'
import desktopPoster from '../assets/videos/newsDeskPoster.avif'
import { useTranslation } from 'react-i18next'

export default function News() {
  const { t } = useTranslation()
  return (
    <article>
      <Video
        mobile={mobile}
        desktop={desktop}
        mobilePoster={mobilePoster}
        desktopPoster={desktopPoster}
        title={t('newsVideo.title')}
        subTitle={t('newsVideo.subTitle')}
        link={'#newsGrid'}
      />
      <NewsGrid id='newsGrid' />
    </article>
  )
}
